<template>
  <v-form v-model="valid" ref="form" class="mt-4">
    <p class="text-subtitle-2">
      Phải chọn người mượn ở 1 trong 3 trường Học viên mượn, Giáo viên mượn hoặc
      Nhân viên mượn bên dưới
    </p>
    <autocomplete-student
      v-if="!teacher && !staff"
      v-model="student"
      item-text="name"
      label="Học viên mượn *"
      outlined
      clearable
      dense
      return-object
      @change="activeButton"
    />
    <autocomplete-teacher
      v-if="!student && !staff"
      v-model="teacher"
      item-text="name"
      label="Giáo viên mượn *"
      outlined
      clearable
      dense
      return-object
      @change="activeButton"
    />
    <autocomplete-staff
      v-if="!student && !teacher"
      v-model="staff"
      item-text="name"
      label="Nhân viên mượn *"
      outlined
      clearable
      dense
      return-object
      @change="activeButton"
    />
    <v-select
      ref="status"
      v-model="status"
      item-text="title"
      item-value="status"
      :items="facilityStatus"
      label="Tình Trạng"
      hide-details
      outlined
      dense
      disabled
    ></v-select>
    <v-row class="mt-2">
      <v-col cols="12" md="6">
        <date-selector
          label="Hạn Trả *"
          :date="currentISODate"
          :min="currentISODate"
          @change="onDeadlineChange"
        ></date-selector>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          class="pt-4"
          ref="date"
          :value="displaydate"
          label="Ngày Mượn"
          prepend-icon="mdi-calendar"
          dense
          disabled
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import AutocompleteTeacher from '@/components/basic/input/AutocompleteTeacher'
import AutocompleteStaff from '@/components/basic/input/AutocompleteStaff'
import DateSelector from '@/components/basic/DateSelector.vue'
import _ from 'lodash'
import moment from 'moment'
export default {
  components: {
    AutocompleteStudent,
    AutocompleteTeacher,
    DateSelector,
    AutocompleteStaff
  },
  props: { facility: Object },
  data: () => ({
    valid: true,
    student: null,
    staff: null,
    status: 'using',
    teacher: null,
    deadline: '',
    date: ''
  }),
  created() {
    this.reset()
  },
  computed: {
    ...mapState('constant', ['facilityStatus', 'facilityTypes']),
    displaydate() {
      return moment(this.date).format('DD/MM/YYYY')
    },
    currentISODate() {
      return moment()
        .add(7, 'h')
        .toISOString()
        .slice(0, 10)
    },
    facilityDuration() {
      return [
        {
          title: 'Trong Ngày',
          value: moment()
            .endOf('date')
            .toISOString()
        },
        {
          title: '1 Ngày',
          value: moment()
            .add(1, 'days')
            .toISOString()
        },
        {
          title: '1 Tuần',
          value: moment()
            .add(1, 'week')
            .toISOString()
        },
        {
          title: '1 Tháng',
          value: moment()
            .add(1, 'months')
            .toISOString()
        },
        {
          title: 'Vô Thời Hạn',
          value: null
        }
      ]
    }
  },
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    onDeadlineChange(value) {
      this.deadline = moment(value, 'YYYY-MM-DD').toISOString()
    },
    activeButton() {
      if (this.teacher || this.staff || this.student) {
        this.$emit('activeButton', false)
      } else this.$emit('activeButton', true)
    },
    reset() {
      if (!this.facility) {
        this.student = null
        this.teacher = null
        this.staff = null
        this.deadline = moment()
          .endOf('date')
          .toISOString()
        this.date = moment().toISOString()
      } else {
        this.student = this.facility.student
        this.teacher = this.facility.teacher
        this.staff = this.facility.staff
        this.deadline = this.facility.deadline
        this.date = this.facility.date
      }
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {
        teacher: _.get(this.teacher, 'id', null),
        student: _.get(this.student, 'id', null),
        staff: _.get(this.staff, 'id', null),
        status: this.status,
        deadline: this.deadline,
        date: this.date
      }
    }
  },
  watch: {
    facility() {
      this.reset()
    }
  }
}
</script>

<style scoped></style>
